import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import moment from 'moment';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Grid, Button } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import { useClientContext } from '../../context/client_context';
import Controls from '../controls/Controls';
import {
  baseUrl,
  gender,
  maritalState,
  titles,
  memberTypes,
  memberStatuses,
  relationShips,
  benefitTypes,
  suffixes
} from '../../utils/constants';

function DependantSub(props) {
  const { currDependant } = useClientContext();
  const navigate = useNavigate();
  const [isMain, setMain] = useState(true);
  const { closePopup } = props;
  const [isDisabled, setDisabled] = useState(false);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const DependantSchema = Yup.object().shape({
    firstName: Yup.string()
      .min(2, 'First Name is too Short!')
      .max(50, 'First Name is too Long!')
      .required('First name required'),
    surname: Yup.string()
      .min(2, 'surname is too Short!')
      .max(50, 'surname is too Long!')
      .required('surname is required'),
    suffix: Yup.string().required('Suffix # is required'),
    dateOfBirth: Yup.date().required('Date of birth is required')
  });

  currDependant.membershipStartDate = moment().format('yyyy-MM-DD');

  const formik = useFormik({
    initialValues: currDependant,
    enableReinitialize: true,
    validationSchema: DependantSchema,
    onSubmit: (values) => {
      values.cif_number = undefined;
      saveClientData(values);
    }
  });

  useEffect(() => {
    if (currDependant.parent_Cif < 0) {
      navigate('/dashboard', { replace: true });
    }
    handleAddDependant();
  }, []);

  const saveClientData = (client) => {
    setDisabled(true);
    client.acceptedBy = sessionStorage.getItem('oldRefId');
    const jsonClient = [];
    jsonClient.push(client);
    fetch(`${baseUrl}/api/client/saveDependant`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          notifyPopup(`Dependant Saved Successfully!`, 'success');
          navigate('/dashboard', { replace: true });
        },
        (error) => {
          notifyPopup(`Error in Saving Client!: ${error}`, 'error');
        }
      );
  };

  const handleAddDependant = () => {
    currDependant.dateOfBirth = '';
    currDependant.surname = '';
    currDependant.firstName = '';
    currDependant.idNumber = '';
    currDependant.cif_number = 0;
    currDependant.title_id = '';
    currDependant.sex_ID = 0;
    currDependant.age = 0;
    currDependant.suffix = '';
    currDependant.dependents = 0;
    currDependant.maritalStatus = '';
    currDependant.memberType_ID = '';
    currDependant.bank_ID = 0;
    currDependant.acc_No = '';
    currDependant.acc_Name = '';
    currDependant.branch_ID = 0;
    currDependant.relationship_ID = '';
    setMain(false);
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={3}>
            <Controls.SelectJson name="title_id" label="Title" options={titles} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.Input name="firstName" label="First Name" />
          </Grid>
          <Grid item xs={12} sm={5}>
            <Controls.Input name="surname" label="Last Name" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.Input name="idNumber" label="Id Number" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.DateTime name="dateOfBirth" label="Date Of Birth" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.SelectJson name="sex_ID" label="Gender" options={gender} />
          </Grid>
          {/* <Grid item xs={12} sm={4}>
            <Controls.Input name="age" label="Age" />
          </Grid> */}
          <Grid item xs={12} sm={4}>
            <Controls.SelectJson
              name="relationship_ID"
              label="Relationship to Main"
              options={relationShips}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.SelectJson name="suffix" label="Suffix" options={suffixes} />
          </Grid>
          <Grid item xs={12} sm={4} paddingBottom={2}>
            <Controls.SelectJson
              name="maritalStatus"
              label="Marital Status"
              options={maritalState}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.SelectJson name="memberType_ID" label="Member Type" options={memberTypes} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.SelectJson
              name="memberStatus"
              label="Member Status"
              options={memberStatuses}
            />
          </Grid>
          <Grid item xs={12} sm={4} paddingBottom={2}>
            <Controls.DateTime name="membershipStartDate" label="Membership Start Date" />
          </Grid>
          <Grid item xs={12} sm={4} paddingBottom={2}>
            <Controls.SelectJson name="benefitType" label="Benefit Type" options={benefitTypes} />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Controls.CheckBox name="beneficiary" label="Nominated" disabled />
          </Grid>
          <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="outlined"
                disabled={isDisabled}
                startIcon={<SaveIcon />}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  );
}

export default DependantSub;
